var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('emap-uploadfile', _vm._g(_vm._b({
    ref: "emapupload",
    attrs: {
      "file-token": _vm.$attrs.value,
      "readonly": _vm.$attrs.disabled
    },
    on: {
      "update:fileToken": _vm.updateToken
    }
  }, 'emap-uploadfile', _vm.$attrs, false), _vm.$listeners), [_c('template', {
    slot: "uploadTip"
  }, [_vm._v(" " + _vm._s(_vm.$attrs.uploadTip) + " ")])], 2);
};

var staticRenderFns = [];
export { render, staticRenderFns };